module.exports = __webpack_public_path__ + "img/41.d1e47b06.jpg";